import React from 'react';
import CompoundInputV3 from './CompoundInputV3';

export type CompoundNumberInputProps = React.ComponentProps<typeof CompoundInputV3.Input> & {
  /**
   * The value of the input number.
   * */
  value: number | null;

  /** The max number that the input can accept */
  max?: number;

  /** The min number that the input can accept */
  min?: number;
};

const CompoundNumberInputV3 = React.forwardRef<HTMLInputElement, CompoundNumberInputProps>(
  function CompoundNumberInput(
    props: CompoundNumberInputProps,
    ref,
  ): React.ReactElement<CompoundNumberInputProps> {
    const { value, max = Number.MAX_SAFE_INTEGER, min = Number.MIN_SAFE_INTEGER, ...rest } = props;
    const validValue = React.useMemo(() => {
      let val = value != undefined ? Number(value) : value; // eslint-disable-line eqeqeq
      if (val) {
        if (val > max) {
          val = max;
        }
        if (val < min) {
          val = min;
        }
      }
      return val;
    }, [value, max, min]);

    return (
      <CompoundInputV3.Input
        type="number"
        value={validValue}
        aria-valuenow={validValue}
        max={max}
        aria-valuemax={max}
        min={min}
        aria-valuemin={min}
        ref={ref}
        placeholder="add"
        onInput={(e: React.FormEvent<HTMLInputElement>) => {
          // Remove leading zeros when they are not followed by another character
          if (e.currentTarget.value) {
            const val = e.currentTarget.value.replace(/^0+(?!\.|$)/, '');
            e.currentTarget.value = val;
          }
        }}
        {...rest}
      />
    );
  },
);

export default CompoundNumberInputV3;
